/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: env.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/helpers/mixins/env.js
 */

export default {
    register(h) {
        const env = (keyName, default_value = null) => {
            const value = process.env['VUE_APP_' + h.toUpper(h.snakeCase(keyName))]
            return value ? value : default_value
        }

        return {env: env}
    }
}
